import React from "react";
import { Modal } from "react-bootstrap";

import { Box, Button, Heading, Icon, Text } from "../elements";

/**
 * @function DeleteModal
 * @description A modal that appears when a user attempts to delete something.
 * @prop {boolean} [isOpen=false] - Whether the modal is open.
 * @prop {function} [onClose=() => {}] - What happens when the modal is closed.
 * @prop {function} [onConfirm=() => {}] - What happens when the user confirms the deletion.
 * @prop {string} [message=""] - The message that is displayed to the user.
 * @returns {object} A JSX element representing the delete modal.
 */
export const DeleteModal = ({ isOpen = false, onClose = () => {}, onConfirm = () => {}, message = "" }) => {
  if (!isOpen) return null;

  return (
    <Modal show={isOpen} onHide={onClose}>
      <Box className="mc-alert-modal">
        <Icon type="new_releases" />
        <Heading as="h3">are your sure!</Heading>
        <Text as="p">{message}</Text>
        <Modal.Footer>
          <Button type="button" className="btn btn-secondary" onClick={onClose}>
            no, close
          </Button>
          <Button type="button" className="btn btn-danger" onClick={onConfirm}>
            yes, delete
          </Button>
        </Modal.Footer>
      </Box>
    </Modal>
  );
};
